import { createAction } from '@reduxjs/toolkit';

export const setHomePage = createAction('content/SET_HOME_PAGE', (payload) => ({ payload }));
export const searchSuggestionClick = createAction('content/SEARCH_SUGGESTION_CLICK', (payload) => ({ payload }));
export const searchSuggestionDisplay = createAction('content/SEARCH_SUGGESTION_DISPLAY');
